import Logo from '../../../../assets/images/logo_radius_trend.png'

const voucherData = Array.from({ length: 12 }, (_, index) => ({
  code: `WHJK-${index + 1}5YHBG`,
  uptime: '24 Jam',
  active: '30 Hari',
  quota: 'Unlimited',
  price: 'Rp 5.000',
  description: 'Voucher Internet',
}))

export const TemplateVoucherPage = () => {

  return (
    <>
      {/* =====================================================
                PAGE
            ===================================================== */}
      <div className="min-h-screen bg-slate-900 py-8 print:bg-white print:p-0">

        {/* =================================================
                    A4 PAPER
                ================================================= */}
        <div className="a4-paper">

          <div className="voucher-grid">

            {voucherData.map((voucher, index) => (
              <VoucherCard
                key={index}
                voucher={voucher}
              />
            ))}

          </div>

        </div>
      </div>


      {/* =====================================================
                ALL STYLE IN THIS FILE
            ===================================================== */}
      <style>{`

                /* =================================================
                   A4
                ================================================= */

                .a4-paper {
                    width: 210mm;
                    min-height: 297mm;

                    margin: 0 auto;
                    padding: 6mm;

                    box-sizing: border-box;

                    background: white;

                    box-shadow:
                        0 10px 40px rgba(0, 0, 0, 0.35);
                }


                /* =================================================
                   GRID
                ================================================= */

                .voucher-grid {
                    display: grid;

                    grid-template-columns:
                        repeat(4, minmax(0, 1fr));

                    /*
                     * Jangan biarkan row memenuhi tinggi A4
                     */
                    grid-auto-rows: max-content;

                    align-content: start;

                    column-gap: 2.5mm;
                    row-gap: 3mm;
                }


                /* =================================================
                   VOUCHER
                ================================================= */

                .voucher-card {
                    width: 100%;

                    aspect-ratio: 1.62 / 1;

                    min-width: 0;

                    overflow: hidden;

                    position: relative;

                    box-sizing: border-box;

                    display: flex;
                    flex-direction: column;

                    background: white;

                    border:
                        0.35mm solid #00b4d8;

                    border-radius: 3mm;

                    color: #0f172a;

                    box-shadow:
                        0 1mm 2mm rgba(15, 23, 42, 0.10);

                    font-family:
                        Inter,
                        Arial,
                        sans-serif;
                }


                /* =================================================
                   HEADER
                ================================================= */

                .voucher-header {
                    display: flex;

                    align-items: center;

                    justify-content: space-between;

                    gap: 1mm;

                    padding:
                        1.8mm
                        2mm
                        1.2mm;

                    background:
                        linear-gradient(
                            135deg,
                            #f0fdff 0%,
                            #ffffff 100%
                        );

                    border-bottom:
                        0.2mm solid #dff7fc;
                }


                .voucher-logo {
                    width: 5mm;
                    height: 5mm;

                    object-fit: contain;

                    flex-shrink: 0;
                }


                .voucher-brand {
                    margin: 0;

                    font-size: 7px;
                    line-height: 1.1;

                    font-weight: 800;

                    color: #0077b6;

                    white-space: nowrap;
                }


                .voucher-subtitle {
                    margin: 0.6mm 0 0;

                    font-size: 4.5px;
                    line-height: 1.1;

                    color: #475569;

                    font-weight: 600;

                    white-space: nowrap;
                }


                /* =================================================
                  PRICE
                ================================================= */

                .voucher-price {
                    padding:
                        1.2mm
                        1.7mm;

                    border-radius: 1.5mm;

                    background: #0077b6;

                    color: white;

                    font-size: 5.5px;

                    line-height: 1;

                    font-weight: 800;

                    white-space: nowrap;
                }



                /* =================================================
                   BODY
                ================================================= */

                .voucher-body {
                    flex: 1;

                    min-height: 0;

                    display: grid;

                    grid-template-columns:
                        minmax(0, 1fr)
                        15mm;

                    gap: 1.5mm;

                    padding:
                        1.5mm
                        2mm
                        1mm;
                }


                /* =================================================
                   LEFT
                ================================================= */

                .voucher-left {
                    min-width: 0;

                    display: flex;

                    flex-direction: column;

                    justify-content: center;
                }


                .voucher-label {
                      margin: 0;

                      font-size: 4.5px;

                      line-height: 1.1;

                      color: #334155;

                      font-weight: 700;

                      letter-spacing: 0.1px;
                  }


                  .voucher-code {
                      margin: 1mm 0 0;

                      font-size: 10px;

                      line-height: 1;

                      color: #006da6;

                      font-weight: 900;

                      letter-spacing: 0.25px;

                      white-space: nowrap;

                      overflow: hidden;

                      text-overflow: ellipsis;
                  }



                /* =================================================
                   INFO
                ================================================= */

                .voucher-info {
                    margin-top: 1.7mm;

                    padding:
                        1.2mm
                        1.5mm;

                    border:
                        0.25mm solid #8ddbea;

                    border-radius: 1.5mm;

                    background: #f4fcfe;
                }


                .voucher-info-row {
                    display: flex;

                    align-items: center;

                    justify-content: space-between;

                    gap: 1mm;

                    font-size: 4px;

                    line-height: 1.55;

                    color: #334155;

                    font-weight: 500;
                }


                .voucher-info-row strong {
                    color: #006da6;

                    font-size: 4px;

                    font-weight: 800;

                    white-space: nowrap;
                }


                /* =================================================
                   RIGHT
                ================================================= */

                .voucher-right {
                    min-width: 0;

                    display: flex;

                    flex-direction: column;

                    align-items: center;

                    justify-content: center;
                }


                /* =================================================
                   QR
                ================================================= */

                .voucher-qr {
                    width: 10mm;
                    height: 10mm;

                    padding: 1mm;

                    box-sizing: border-box;

                    border:
                        0.3mm solid #0077b6;

                    border-radius: 1.5mm;

                    background: white;

                    display: flex;

                    align-items: center;

                    justify-content: center;
                }


                .qr-pattern {
                    width: 100%;
                    height: 100%;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    border-radius: 0.5mm;

                    background:
                        repeating-linear-gradient(
                            45deg,
                            #0f172a 0px,
                            #0f172a 1px,
                            white 1px,
                            white 2px
                        );

                    color: white;

                    font-size: 3px;

                    font-weight: 900;
                }


                .voucher-scan {
                    margin: 0.8mm 0 0;

                    font-size: 4px;

                    line-height: 1.1;

                    color: #334155;

                    font-weight: 600;

                    text-align: center;

                    white-space: nowrap;
                }

                /* =================================================
                   FOOTER
                ================================================= */

                .voucher-footer {
                    display: flex;

                    align-items: center;

                    justify-content: space-between;

                    gap: 1mm;

                    padding:
                        1.2mm
                        2mm;

                    background: #00b4d8;

                    color: white;

                    font-size: 4px;

                    line-height: 1.1;

                    font-weight: 800;

                    white-space: nowrap;
                }


                /* =================================================
                   PRINT
                ================================================= */

                @media print {

                    @page {
                        size: A4 portrait;
                        margin: 0;
                    }


                    html,
                    body {
                        width: 210mm;

                        margin: 0;
                        padding: 0;

                        background: white !important;
                    }


                    body {
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }


                    .a4-paper {
                        width: 210mm;
                        height: 297mm;

                        min-height: 297mm;

                        margin: 0;

                        padding: 6mm;

                        box-shadow: none;

                        overflow: hidden;
                    }


                    .voucher-grid {
                        grid-template-columns:
                            repeat(4, minmax(0, 1fr));

                        grid-auto-rows: max-content;

                        align-content: start;

                        column-gap: 2.5mm;
                        row-gap: 3mm;
                    }


                    .voucher-card {
                        break-inside: avoid;

                        page-break-inside: avoid;

                        box-shadow: none;
                    }
                }


                /* =================================================
                   RESPONSIVE SCREEN
                ================================================= */

                @media screen and (max-width: 900px) {

                    .a4-paper {
                        transform-origin: top center;

                        transform: scale(
                            min(
                                1,
                                calc(
                                    (100vw - 30px) / 210mm
                                )
                            )
                        );
                    }

                }

            `}</style>
    </>
  )
}


/* =============================================================
   VOUCHER CARD
============================================================= */

const VoucherCard = ({ voucher }) => {

  return (
    <div className="voucher-card">

      {/* =================================================
               HEADER
            ================================================= */}

      <div className="voucher-header">

        <div className="flex items-center gap-[1mm] min-w-0">

          <img
            src={Logo}
            alt="Radius Trend"
            className="voucher-logo"
          />

          <div className="min-w-0">

            <p className="voucher-brand">
              Radius Trend
            </p>

            <p className="voucher-subtitle">
              WiFi Voucher
            </p>

          </div>

        </div>


        {/* PRICE */}

        <div className="voucher-price">
          {voucher.price}
        </div>

      </div>


      {/* =================================================
               BODY
            ================================================= */}

      <div className="voucher-body">

        {/* LEFT */}

        <div className="voucher-left">

          <p className="voucher-label">
            KODE VOUCHER
          </p>

          <p className="voucher-code">
            {voucher.code}
          </p>


          {/* INFO */}

          <div className="voucher-info">

            <div className="voucher-info-row">
              <span>
                Up Time
              </span>

              <strong>
                {voucher.uptime}
              </strong>
            </div>


            <div className="voucher-info-row">
              <span>
                Masa Aktif
              </span>

              <strong>
                {voucher.active}
              </strong>
            </div>


            <div className="voucher-info-row">
              <span>
                Kuota
              </span>

              <strong>
                {voucher.quota}
              </strong>
            </div>

          </div>

        </div>


        {/* RIGHT */}

        <div className="voucher-right">

          <div className="voucher-qr">

            <div className="qr-pattern">
              QR
            </div>

          </div>

          <p className="voucher-scan">
            Scan untuk login
          </p>

        </div>

      </div>
      {/* =================================================
               FOOTER
            ================================================= */}
      <div className="voucher-footer">
        <span>
          {voucher.description}
        </span>
        <span>
          Jangan buang kode voucher
        </span>
      </div>
    </div>
  )
}